import React from 'react';
import {
  Gear, GearsContainer, GearContainer, Container, TextContainer,
} from './styles';

export const MaintenancePage = () => (
  <Container>
    <GearsContainer>
      <GearContainer>
        <Gear
          direction="left"
          size="medium"
        />
      </GearContainer>
      <GearContainer offset={85}>
        <Gear
          size="medium"
        />
      </GearContainer>
      <GearContainer>
        <Gear
          direction="left"
          size="medium"
        />
      </GearContainer>
    </GearsContainer>
    <TextContainer>
      This page is under construction
    </TextContainer>
  </Container>
);
